import BaseValidator from 'ember-cp-validations/validators/base';

export default BaseValidator.extend({
  async validate(value, options, model) {
    let valueId = value?.get('id') ?? value?.id;

    if (!valueId) {
      return true;
    }

    let [legalContext, newsletterTargetContext] = await Promise.all([
      model.legalContext,
      value.get('legalContext'),
    ]);

    if (legalContext?.id === newsletterTargetContext?.id) {
      return true;
    }

    return this.createErrorMessage('matching-legal-context', value, options);
  },
});
